import { withBasePath } from '@/lib/config';
import { TEAM_LOGO_FILES } from '@/lib/predictor';

type TeamLogoProps = {
  short: string;
  variant: 'mono' | 'colour';
  size: number;
  className?: string;
  alt?: string;
};

/**
 * Renders a union's logo from public/images/logos/. The `-mono` SVG is the
 * unselected state; the matching non-suffixed file is the selected/colour
 * state. Filename prefixes vary per team (e.g. ARG → `arg-los-pumas`) so
 * they are looked up via TEAM_LOGO_FILES.
 *
 * Plain <img> rather than next/image — SVGs gain nothing from Image
 * optimisation, and next/image needs `dangerouslyAllowSVG` to render SVGs.
 */
export default function TeamLogo({ short, variant, size, className = '', alt }: TeamLogoProps) {
  const files = TEAM_LOGO_FILES[short];
  const src = withBasePath(`/images/logos/${files[variant]}.svg`);
  return (
    <img
      src={src}
      width={size}
      height={size}
      alt={alt ?? short}
      className={`object-contain ${className}`.trim()}
      loading="lazy"
      decoding="async"
    />
  );
}
